<script setup lang="ts">
interface Props {
    title: string;
    imageUrl: string;
    price?: string;
    isSelected: boolean;
    idToSelect: string;
}
const props = defineProps<Props>();

const emit = defineEmits<{ (e: "select", id: string): void }>();
</script>

<template>
    <div
        class="tiw__handedDevice"
        :class="{ selected: props.isSelected }"
        @click="emit('select', props.idToSelect)"
    >
        <div class="tiw__handedDevice__container">
            <figure class="tiw__handedDevice__figure">
                <img class="tiw__handedDevice__image" :src="props.imageUrl" alt="Handed device" />
            </figure>

            <div class="tiw__handedDevice__body">
                <p class="tiw__handedDevice__title">{{ props.title }}</p>
                <p class="tiw__handedDevice__price">{{ props.price }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.tiw {
    &__handedDevice {
        border-radius: 8px;
        background-color: #f4f6f8;
        margin: 0;
        padding: 12px 16px;
        border-width: 2px;
        border-style: solid;
        border-color: transparent;

        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

        cursor: pointer;

        @media screen and (max-width: 767px) {
            padding: 8px;
        }

        &.selected {
            border-color: var(--custom-color-main);
        }

        &:not(.selected):hover {
            transform: translateY(-2px);
            box-shadow:
                0 7px 13px -2px rgba(50, 50, 93, 0.25),
                0 4px 8px -4px rgba(0, 0, 0, 0.3);
        }

        &__info-block {
            display: flex;
            gap: 16px;
            justify-content: space-between;
            font-size: 14px;
            p {
                margin: 0;
            }

            &__line {
                margin: 6px 0;
            }

            &__discount {
                font-size: 11px;
                margin-right: 4px;
            }
        }

        &_noGrade {
            margin-bottom: 0;
        }

        &__container {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            align-self: stretch;
            position: relative;

            @media screen and (max-width: 767px) {
                gap: 8px;
            }
        }

        figure {
            margin: 0;
            padding: 0;
        }

        &__figure {
            width: 72px;
            height: 72px;
            flex: 0 0 72px;
            user-select: none;
        }

        &__image {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        &__body {
            user-select: none;
        }

        &__title {
            font-size: calc(var(--custom-font-size) * 1); // 14px -> 14px
            font-weight: 700;
            line-height: 1.429; /* 142.857% */
            margin: 0;
            padding: 0;
            margin-bottom: 4px;
        }

        &__price {
            padding: 0;
            margin: 0;
            margin-bottom: 4px;
            font-size: calc(var(--custom-font-size) * 1); // 14px -> 14px
            line-height: 1.429;

            li {
                display: inline;

                &:not(:last-child) {
                    &::after {
                        content: " • ";
                        color: var(--custom-color-text); // color: #808d9a;
                        //filter: grayscale(0.55);
                    }
                }

                > span {
                    white-space: nowrap;
                }
            }
        }

        &__current-grade {
            margin-top: 12px;

            h5 {
                margin: 0;
                margin-bottom: 4px;
            }
        }

        &__no-grade {
            margin-top: 12px;
            padding: 8px 10px;
            text-align: center;
            border-radius: 6px;
            background-color: #fef2f4;
            font-size: calc(var(--custom-font-size) * 1.143); // 14px -> 16px
            font-weight: 700;
            line-height: 1.25; /* 125% */
            color: #f14459;
        }
    }
}
</style>
